module.exports = __webpack_public_path__ + "img/model_bg.99ac244b.jpg";